import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Modal, Typography, Button, Flex } from '@app/ui';
import { createPortal } from 'react-dom';
import { CloseOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

export const DeleteReportModal = ({
    visible,
    onCancel,
    onConfirm,
    entity,
    loading,
}: {
    visible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    entity: string;
    loading: boolean;
}) => {
    const { t } = useTranslation('tools');

    if (!visible) return null;

    const modalRoot = document.getElementById('modal-window');
    if (!modalRoot) return null;

    return createPortal(
        <Modal
            open={visible}
            onCancel={onCancel}
            closable={false}
            footer={null}
            width={400}
            maskClosable
            className="delete-confirm-modal"
        >
            <Flex gap={16} align="left">
                <i
                    className="fa-solid fa-triangle-exclamation"
                    style={{
                        color: '#D40F7D',
                        fontSize: 20,
                        width: 24,
                        height: 24,
                    }}
                />
                <Flex vertical gap={16} align="left">
                    <Text strong style={{ fontSize: 16 }}>
                        {t('reports.modals.delete.title')}
                    </Text>
                    <Paragraph style={{ textAlign: 'left' }}>
                        <Trans
                            i18nKey="reports.modals.delete.message"
                            ns="tools"
                            values={{ entity }}
                            components={[<Text strong key="entity" />]}
                        />
                    </Paragraph>
                    <Flex justify="center" gap={8}>
                        <Button
                            variant="solid"
                            color="default"
                            icon={<CloseOutlined />}
                            onClick={onCancel}
                        >
                            {t('reports.buttons.cancel')}
                        </Button>
                        <Button
                            variant="solid"
                            color="danger"
                            onClick={onConfirm}
                            loading={loading}
                            disabled={loading}
                        >
                            {t('reports.buttons.deleteConfirm')}
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </Modal>,
        modalRoot,
    );
};
